// =========================================================
// * Vue Material Dashboard - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
// * Licensed under MIT (https://github.com/creativetimofficial/vue-material-dashboard/blob/master/LICENSE.md)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/**
 * for xlsx-populate
 */
import { Buffer } from 'buffer';
// @ts-ignore
window.Buffer = Buffer;

import Vue, { createApp } from 'vue';

// @ts-ignore
import App from '@/App.vue';

import { myrouter } from '@/router';
import { mystore } from '@/store';
import Chartist from 'chartist';
import { createPinia } from 'pinia';

// Plugins
import GlobalComponents from '@/globalComponents';
import GlobalDirectives from '@/globalDirectives';
import Notifications from '@/components/NotificationPlugin';

// Axiosの共通処理（エラーハンドリングなど）
import '@/coreInfrastructureModule/axios/axiosInterceptors';

// MaterialDashboard plugin
// import MaterialDashboard from '@/material-dashboard';

// FontAwesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { i18nModule } from '@/i18n';
import VTooltip from 'v-tooltip';
import { initProcess } from '@/initProcess';
import SideBar from '@/components/SidebarPlugin';
import './index.scss'; //tailwindcss
import { splitNumberFormat } from './utils/display/numbers';

// Prototype Methods
import '@/coreDomainsModule/extends/array';

// md-components
// import mdContent from '@/components/MaterialDesign/MdContent.vue'
import './components/MaterialDesign/vue-material/base/index.scss';
// import mdField from '@/components/MaterialDesign/MdField.vue'
// import mdInput from '@/components/MaterialDesign/vue-material/MdInput/MdInput.vue'
import { registerMdField } from '@/components/MaterialDesign/vue-material/MdField/index';
import mdToolbar from '@/components/MaterialDesign/vue-material/MdToolbar/MdToolbar.vue';
import { mdDialogRegistComponent } from '@/components/MaterialDesign/vue-material/MdDialog';
import { defineMdCard } from '@/components/MaterialDesign/vue-material/MdCard';
import mdList from '@/components/MaterialDesign/vue-material/MdList/MdList.vue';
import { mdTableRegistComponent } from '@/components/MaterialDesign/vue-material/MdTable';
import { mdIconDefine } from '@/components/MaterialDesign/vue-material/MdIcon';
import { defineContentComponent } from '@/components/MaterialDesign/vue-material/MdContent';
export const app = createApp({
  el: '#app',
  data() {
    return { Chartist: Chartist };
  },
  render: (h) => h(App),
});
app.use(i18nModule);
app.use(mystore);
app.use(myrouter);
defineContentComponent(app);
mdIconDefine(app);
// material()
// app.component("MdField", mdField);
// app.component("MdInput", mdInput);
const pinia = createPinia();
app.use(pinia);
app.component('MdToolbar', mdToolbar);
app.component('MdList', mdList);
app.component('MdList', mdList);
mdDialogRegistComponent(app);
defineMdCard(app);
mdTableRegistComponent(app);
registerMdField(app);
app.use(SideBar);
// app.component('FaIcon', FontAwesomeIcon);
// library.add(faUserSecret);

initProcess(); // IndexedDBなどの初期化処理

// Vue.prototype.$Chartist = Chartist;
// app.use(MaterialDashboard);
app.use(GlobalComponents);
app.use(GlobalDirectives);
app.use(Notifications);
app.use(VTooltip);
app.mount('#app');
// Vue.use(VueCompositionAPI);

/* eslint-disable no-new */

// vue 2.x
// new Vue({
//   el: '#app',
//   i18n,
//   data: {
//     Chartist: Chartist,
//   },
//   render: (h) => h(App),
//   store,
//   router,
// });
